export const borderColorCotton = '#FF4069';
export const colorCotton = '#FFA0B4';
export const borderColorSintetico = '#059BFF';
export const colorSintetico = '#82CDFF';
export const color1 = '#ffc605';
export const color2 = '#1FFFD2';
export const color3 = '#FF8EF7';
export const color4 = '#8C96FF';
export const color5 = '#FFB08F';
export const color6 = '#84E3A3';
export const gray700= '#616161';
export const error = '#EF4444';
export const despachado = '#CCCC'; 
export const firmaDespachado = '#679F37';
export const borderRadius = 10;
export const heightKPI = '150'


export const colors = {
    white: '#fff',
    backgroundColor: '#fff',
    backgroundColorDark: '#f5f5f5',
    primary: 'rgba(156,39,176,1)',
    borderRadius: 10,
    borderColorCotton: '#FF4069',
    colorCotton: '#FFA0B4',
    borderColorSintetico: '#059BFF',
    colorSintetico: '#82CDFF',
    heightKPI: '150',
    primary100: '#F6E9F7',
    primary200: '#EDD5F0',
    primary300: '#E2C0E7',
    primary400: '#D9ABE0',
    primary500: '#D095D8',
    primary600: '#C680D0',
    primary700: '#BC6AC8',
    primary800: '#B255C0',
    primary900: '#A63EB8',
    success: '#25D991',
    // primary550: '#9c27b0',

    error: '#EF4444',

    green: '#679F37',

    // GRAY
    gray50: '#fafafa',
    gray100: '#F5F5F5',
    gray200: '#ECECEC',
    gray300: '#E0E0E0',
    gray400: '#BDBDBD',
    gray500: '#9E9E9E',
    gray600: '#757575',
    gray700: '#616161',
    gray800: '#424242',
    gray900: '#212121',
    input: 'rgba(230,223,234)'
}